import React, { useState } from "react"
import { usePermissions, useTranslate } from 'react-admin';
import { useTheme, makeStyles, Box, AppBar, Tabs, Tab, Typography } from "@material-ui/core";
import PropTypes from 'prop-types';
import SessionReport from "./sessionreport";
import Configuration from "./configuration";
import ReportSession from "./ReportSession";

const useStyles = makeStyles(theme => ({
  selected: {
    backgroundColor:  theme.tab.selectedColor,
    fontFamily: 'UniviaPro-Bold',
    fontSize: '11px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: ' 0.44px',
    color: '#ffffff !important',
  },
  indicator: {
    backgroundColor: '#ffffff',
    height: 5

  },
  tabRoot: {
    width: 155,
    height: 60,
    fontFamily: 'UniviaPro-Bold',
    fontSize: '11px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: ' 0.44px',
    color: 'rgba(255, 255, 255, 0.7)',
  },
  dialogPaper: {
    minHeight: '90vh',
    maxHeight: '90vh',
    backgroundColor: theme.palette.background.default
  },
  textClose: {
    fontFamily: 'UniviaPro-Bold',
    fontSize: '10px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: ' 0.4px',
    color: '#4f5064',
  },
  btnClose: {
    width: '25px',
    height: '25px',
    border: 'solid 2px #e5f1f8',
    backgroundColor: '#ffffff',
  },
  TitleCluster: {
    fontFamily: 'UniviaPro-Medium',
    fontSize: '18px',
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.2,
    letterSpacing: 'normal',
    color: '#4f5064',
  }
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box display='flex' justifyContent='center'>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

const UsageData = () => {
  const theme = useTheme();
  const classes = useStyles()
  const { permissions, loaded } = usePermissions();
  const translate = useTranslate()
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  if (!loaded) return null
  return (

    <Box width='100%' display='flex' justifyContent='center'>
      <Box width='80%' mt={5} position='relative'>
        <AppBar position="static" color='primary'>
          <Tabs
            value={value}
            onChange={handleChange}
            classes={{
              indicator: classes.indicator
            }}

          >
            <Tab classes={{ root: classes.tabRoot, selected: classes.selected }} label={translate(`pos.usageData.sessionReport`)}{...a11yProps(0)} />
            <Tab classes={{ root: classes.tabRoot, selected: classes.selected }} label={translate(`pos.usageData.configuration`)} {...a11yProps(1)} />

          </Tabs>
        </AppBar>
        <TabPanel style={{ padding: 0 }} value={value} index={0} dir={theme.direction}>
          {/* <SessionReport /> */}
          <ReportSession permissions={!permissions.functionAction.find(value => value.function === 'Usage data' && value.isCreate)}></ReportSession>
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          <Configuration />
        </TabPanel>
      </Box>
    </Box>

  )
}
export default UsageData